// eslint-disable-next-line import/no-unresolved -- eslint-import-resolver-node doesn't support package.json "exports" subpaths
import * as configcat from '@configcat/sdk/browser';

const FRONTEND_MIGRATION_SDK = 'FRONTEND_MIGRATION_SDK';

export class ConfigCatWrapper {
    isUserSet = false;

    constructor(sdkKeysByName = {}) {
        this.clients = {};

        Object.entries(sdkKeysByName).forEach(([name, sdkKey]) => {
            if (!sdkKey) return;

            const logger = configcat.createConsoleLogger(configcat.LogLevel.Off);
            this.clients[name] = configcat.getClient(sdkKey, configcat.PollingMode.AutoPoll, { logger });
        });
    }

    setUser(userId, attributes = {}) {
        const user = new configcat.User(userId, null, null, attributes);
        Object.values(this.clients).forEach(client => client.setDefaultUser(user));
        this.isUserSet = true;
    }

    getValue(name, key, defaultValue) {
        const client = this.clients[name];
        if (!client) return Promise.resolve(defaultValue);

        return client.getValueAsync(key, defaultValue);
    }

    /**
     * Simple helper function to determine if the user should be using the new frontend
     * @returns {Promise<boolean>} - Returns true if the user should be using the new frontend, false otherwise
     * */
    shouldUserUseNewFrontend() {
        if (!this.isUserSet) return false;

        return this.getValue(FRONTEND_MIGRATION_SDK, 'shouldUseNewFrontend', false);
    }

    getFrontendRedirectUrl() {
        return this.getValue(FRONTEND_MIGRATION_SDK, 'newElementaryFrontendUrl', window.location.origin);
    }
}

export default new ConfigCatWrapper(window.config.CONFIGCAT);
